<template>
  <div
    id="impersonation-banner"
    class="bg-red-600 flex gap-4 h-6 justify-center p-0.5 text-sm text-white w-full"
    data-test="impersonation-banner">
    <span>{{ t('impersonation.loggedinAs') }}</span>
    <span
      id="copy-username"
      class="cursor-pointer hover:underline"
      @click="copyUsername">
      {{ account.username }}
    </span>
    <span
      v-if="name"
      id="copy-name"
      class="cursor-pointer hover:underline"
      @click="copyName">
      ({{ name }})
    </span>
  </div>
</template>

<script setup lang="ts">
import {ref} from 'vue';
import {useI18n} from 'vue-i18n';
import useAccount from '@/composables/useAccount/useAccount';

const {t} = useI18n();
const {account} = useAccount();

const name = ref(`${account.value.first_name} ${account.value.last_name}`.trim());

const copyUsername = (): Promise<void> => navigator.clipboard.writeText(account.value.username);
const copyName = (): Promise<void> => navigator.clipboard.writeText(name.value);
</script>
